
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const LoginPage = lazy(() => import('../pages/login/page'));
const DashboardPage = lazy(() => import('../pages/portal/dashboard/page'));
const MissionsPage = lazy(() => import('../pages/portal/missions/page'));
const RewardsPage = lazy(() => import('../pages/portal/rewards/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/portal/dashboard',
    element: <DashboardPage />,
  },
  {
    path: '/portal/missions',
    element: <MissionsPage />,
  },
  {
    path: '/portal/rewards',
    element: <RewardsPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
